import { render, staticRenderFns } from "./social-callback.vue?vue&type=template&id=6a81be0c&"
import script from "./social-callback.vue?vue&type=script&lang=ts&"
export * from "./social-callback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports